import React from 'react'
import Particle from 'react-particles-js'
import './main.css'

const Particles = () => {
    return (
        <Particle
        className="particle"
    params={{
	    "particles": {
	        "number": {
	            "value": 100
	        },
	        "size": {
	            "value": 3
	        }
	    },
	    "interactivity": {
	        "events": {
	            "onhover": {
	                "enable": true,
	                "mode": "repulse"
	            }
	        }
	    }
	}} />
    )
}

export default Particles
